<script>
  import Products from "$lib/assets/imgs/Products@2x.webp";
</script>

<section class="mt-28 px-4">
  <div
    class="container mx-auto lg:h-[555px] w-full overflow-hidden bg-white rounded-2xl shadow-sm flex flex-wrap lg:flex-nowrap"
  >
    <!-- Text Side -->
    <div class="lg:w-1/2 p-8 md:p-16 lg:p-20 flex flex-col justify-center">
      <div
        class="inline-flex items-center gap-2 bg-green-100 text-green-700 text-sm font-semibold px-4 py-1.5 rounded-full w-fit mb-6"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M13 10V3L4 14h7v7l9-11h-7z"
          />
        </svg>
        Quick Setup
      </div>
      <h2 class="text-2xl lg:text-4xl font-bold text-gray-900 leading-tight">
        Online store in
        <span class="text-green-500">minutes</span>
      </h2>
      <p class="text-gray-600 text-lg mt-4 leading-relaxed max-w-md">
        Uzakitu makes it easier to setup an E-commerce store for your business
        right on your existing or new website.
      </p>
      <div class="mt-8 flex items-center gap-6">
        <a href="/sign-up" class="green-btn-full inline-block">Get Started</a>
        <a
          href="#pricing"
          class="text-green-600 font-semibold hover:text-green-700 transition-colors flex items-center gap-1"
        >
          View Pricing
          <svg
            class="w-4 h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </a>
      </div>
    </div>
    <!-- Image Side -->
    <div
      class="lg:w-1/2 p-8 bg-gradient-to-br from-green-50 to-green-100 flex items-center justify-center"
    >
      <img
        class="object-contain max-h-full rounded-lg shadow-lg"
        src={Products}
        alt="Products Dashboard"
        loading="lazy"
      />
    </div>
  </div>
</section>
